import React from "react";
import ModalConfirmarInfoPersonal from "../../../componentesEspeciales/cuenta/modalConfirmarInfo";

const IDIOMAS_DISPONIBLES = [
  'Español', 'Inglés', 'Portugués', 'Francés', 'Alemán',
  'Italiano', 'Chino (Mandarín)', 'Japonés', 'Árabe', 'Ruso', 'Coreano', 'Holandés',
];



function InfoProfesional({ usuario, profesional, cambiarCampoProfesional, guardarPerfil }) {
  const bloqueado = usuario?.perfilProfesional?.completo === true;

  const idiomasSeleccionados = profesional.idiomas
    ? profesional.idiomas.split(", ").filter(Boolean)
    : [];

  function toggleIdioma(idioma) {
    if (bloqueado) return;
    const nuevos = idiomasSeleccionados.includes(idioma)
      ? idiomasSeleccionados.filter(i => i !== idioma)
      : [...idiomasSeleccionados, idioma];
    cambiarCampoProfesional("idiomas", nuevos.join(", "));
  }


    return (
        <>
            {/* TITULO Y BOTONES INFORMACIÓN PROFESIONAL */}
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h2 className="mb-0">Información profesional</h2>
                <div className="d-flex gap-2">
                    {/* BOTÓN GUARDAR */}
                    {usuario?.perfilProfesional?.completo ? null : (
                        <button
                            className="btn btn-primary"
                            onClick={() => { guardarPerfil("Profesional"); }}
                        >
                            <i className="bi bi-check2-circle me-2"></i>
                            Guardar info Profesional
                        </button>
                    )}

                    {/* INFO PROFESIONAL CONFIRMADA */}
                    {usuario?.perfilProfesional?.completo && (
                        <button className="btn btn-success" onClick={() => {}}>
                            <i className="bi bi-patch-check-fill me-2"></i>
                            Info profesional confirmada
                        </button>
                    )}
                </div>
            </div>

            {/* TIP  */}
            <div className="alert mb-4" style={{ backgroundColor: "var(--color-bg-accent-subtle)", border: "1px solid var(--azul-cielo)", color: "var(--color-text-primary)" }}>
                <div className="d-flex flex-column gap-1">
                    <span style={{ color: "var(--color-text-primary)", fontWeight: 500 }}>Esta información no es obligatoria, pero entre más información tengamos de ti, mejor.</span>
                </div>
            </div>

            <div className="row g-3">
                {/* TÍTULO PROFESIONAL */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Título profesional"
                            value={profesional.tituloProfesional}
                            onChange={(e) => cambiarCampoProfesional("tituloProfesional", e.target.value)}
                            readOnly={bloqueado}
                        />
                        <label>Título profesional</label>
                    </div>
                </div>

                {/* PROFESIÓN PRINCIPAL */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Profesión principal"
                            value={profesional.profesionPrincipal}
                            onChange={(e) => cambiarCampoProfesional("profesionPrincipal", e.target.value)}
                            readOnly={bloqueado}
                        />
                        <label>Profesión principal</label>
                    </div>
                </div>

                {/* AÑOS DE EXPERIENCIA */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="number"
                            min="0"
                            className="form-control"
                            placeholder="Años de experiencia"
                            value={profesional.anosExperiencia}
                            onChange={(e) => cambiarCampoProfesional("anosExperiencia", e.target.value)}
                            readOnly={bloqueado}
                        />
                        <label>Años de experiencia</label>
                    </div>
                </div>

                {/* EMPRESA ACTUAL */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Empresa actual"
                            value={profesional.empresaActual}
                            onChange={(e) => cambiarCampoProfesional("empresaActual", e.target.value)}
                            readOnly={bloqueado}
                        />
                        <label>Empresa actual</label>
                    </div>
                </div>

                {/* CARGO ACTUAL */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Cargo actual"
                            value={profesional.cargoActual}
                            onChange={(e) => cambiarCampoProfesional("cargoActual", e.target.value)}
                            readOnly={bloqueado}
                        />
                        <label>Cargo actual</label>
                    </div>
                </div>

                {/* IDIOMAS */}
                <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold mb-1">Idiomas</label>
                    <div className="dropdown">
                        <button
                            type="button"
                            className="btn btn-outline-secondary w-100 text-start d-flex justify-content-between align-items-center"
                            data-bs-toggle={bloqueado ? undefined : "dropdown"}
                            data-bs-auto-close="outside"
                            disabled={bloqueado}
                            style={{ minHeight: "48px" }}
                        >
                            <span className="text-truncate" style={{ fontSize: 14 }}>
                                {idiomasSeleccionados.length > 0
                                    ? idiomasSeleccionados.join(", ")
                                    : <span className="text-muted">Selecciona idiomas</span>}
                            </span>
                            <i className="bi bi-chevron-down ms-2 flex-shrink-0"></i>
                        </button>
                        <ul className="dropdown-menu w-100 p-2" style={{ maxHeight: 260, overflowY: "auto" }}>
                            {IDIOMAS_DISPONIBLES.map(idioma => (
                                <li key={idioma}>
                                    <button
                                        type="button"
                                        className="dropdown-item d-flex align-items-center gap-2 rounded"
                                        onClick={() => toggleIdioma(idioma)}
                                    >
                                        <input
                                            type="checkbox"
                                            className="form-check-input flex-shrink-0"
                                            checked={idiomasSeleccionados.includes(idioma)}
                                            readOnly
                                        />
                                        <span>{idioma}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {idiomasSeleccionados.length > 0 && (
                        <div className="d-flex flex-wrap gap-1 mt-2">
                            {idiomasSeleccionados.map(i => (
                                <span key={i} className="badge rounded-pill bg-primary-subtle text-primary-emphasis" style={{ fontSize: 12 }}>
                                    {i}
                                    {!bloqueado && (
                                        <button
                                            type="button"
                                            className="btn-close btn-close ms-1"
                                            style={{ fontSize: 8 }}
                                            onClick={() => toggleIdioma(i)}
                                        />
                                    )}
                                </span>
                            ))}
                        </div>
                    )}
                </div>

                {/* HABILIDADES */}
                <div className="col-12">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Habilidades"
                            value={profesional.habilidades}
                            onChange={(e) => cambiarCampoProfesional("habilidades", e.target.value)}
                            readOnly={bloqueado}
                        />
                        <label>Habilidades</label>
                        <p className="textoBajoInput">Ej: Diseño web, atención al cliente, edición de video</p>
                    </div>
                </div>

                {/* DESCRIPCIÓN PROFESIONAL */}
                <div className="col-12">
                    <div className="form-floating">
                        <textarea
                            readOnly={bloqueado}
                            className="form-control"
                            placeholder="Descripción profesional"
                            style={{ height: "130px" }}
                            value={profesional.descripcionProfesional}
                            onChange={(e) => cambiarCampoProfesional("descripcionProfesional", e.target.value)}
                        ></textarea>
                        <label>Descripción profesional</label>
                    </div>
                </div>
            </div>

            {/* CONFIRMAR INFORMACIÓN PROFESIONAL */}
            {usuario?.perfilProfesional?.completo ? null : (
                <ModalConfirmarInfoPersonal cualInfo={"Profesional"} datos={profesional} idUsuario={usuario.idUsuario} />
            )}

            <hr className="my-4" />
        </>
    );
}

export default InfoProfesional;